/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Closeeditorbutton2Inputs */
/** @typedef {{}} Closeeditorbuttontitle3Inputs */
/** @typedef {{}} Confirmcloseeditor2Inputs */
/** @typedef {{}} Defaultexample1Inputs */
/** @typedef {{}} Openeditorbutton2Inputs */
/** @typedef {{ "background:darkgreen": NonNullable<unknown> }} Readme1Inputs */
/** @typedef {{}} Redirectlabel1Inputs */
/** @typedef {{}} Redirectplaceholder1Inputs */
/** @typedef {{}} Rulesreminder1Inputs */


export const closeeditorbutton2 = /** @type {(inputs: Closeeditorbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close the editor`)
};

export const closeeditorbuttontitle3 = /** @type {(inputs: Closeeditorbuttontitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close the Markdown editor`)
};

export const confirmcloseeditor2 = /** @type {(inputs: Confirmcloseeditor2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you really want to close the Markdown editor?

Your changes will be lost if you haven't copied the content.`)
};

export const defaultexample1 = /** @type {(inputs: Defaultexample1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello !
Hi !

![](assets/perso_educajou.svg)

![](assets/brigit_et_komit.png)
Brigit & Komit
`)
};

export const openeditorbutton2 = /** @type {(inputs: Openeditorbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the online editor`)
};

export const readme1 = /** @type {(inputs: Readme1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`# MemoryMD

**MemoryMD** is a free and open-source application that lets you create matching games from simple Markdown text.

You can create games that match: text, images, or sound. All combinations are possible: text/text, text/image, text/sound, image/sound, image/image, sound/sound.

## ⚙️ How it works

To use the MemoryMD application, you need to create a Markdown file with the following syntax:

- Separate each card with a blank line.
- If you want to match two elements, write the first element on one line, then go to the next line to write the second element: use Markdown syntax to write your text or insert an image.
- If only one line is present, instead of matching two different elements, the card will be duplicated twice, and the goal will be to find the identical card.

You can test the online editor to understand how it works <!--BUTTON_OPEN_EDITOR-->

To share your Memory game, you need to host your Markdown content in an online file (for example, with CodiMD).

Your Memory game will then be available at the following address: \`https://memorymd.forge.apps.education.fr/#URL_OF_THE_MARKDOWN_FILE\`

<!--INPUT_MARKDOWN-->

You can add a title and/or instructions to your Memory game.
- For the title, use a level 1 heading in Markdown
- For the instructions, use a blockquote

You can also use an audio file with a line starting with \`audio: \` followed by the URL of your file.

## 👀 Examples

- [Basic example](https://memorymd.forge.apps.education.fr/#https://codimd.apps.education.fr/5cw7PygxR72Obz8K8mRwew) to understand the structure of a Memory game. [View the source](https://codimd.apps.education.fr/5cw7PygxR72Obz8K8mRwew) to then create your own Memory game.
- [Example of a Memory game with sounds](http://memorymd.forge.apps.education.fr/#https://codimd.apps.education.fr/fk4QyJ7nSF6dHb1mHOzGag) and text/sound and image/sound associations. [View the source](https://codimd.apps.education.fr/fk4QyJ7nSF6dHb1mHOzGag)

## 🚀 Advanced features

You can add features with a YAML header.

\`\`\`yaml
---
maths: true
wintext: Excellent, you did perfectly!
style: body${i?.["background:darkgreen"]}
---
\`\`\`

- \`maths: true\` enables LaTeX math formulas
- \`wintext:\` allows you to customize the message displayed when the memory game is completed
- \`style:\` allows you to add custom CSS styles

## 🙋‍♀️ Contribute

Thank you for your interest in MemoryMD! Any contribution is appreciated!

- Feel free to suggest a new feature or report a bug. For this, you can use the application's [tickets](https://forge.apps.education.fr/memorymd/memorymd.forge.apps.education.fr/-/issues/new) or send an [email](mailto:forge-apps+guichet+memorymd-memorymd-forge-apps-education-fr-6780-issue-@phm.education.gouv.fr).
- If you would like to contribute to the MemoryMD code, feel free to check the tickets and [contact the project lead](http://eyssette.forge.apps.education.fr/).

## 👩‍⚖️ License

MemoryMD is distributed under the MIT License.

## 🙏 Credits

MemoryMD was written based on [Nate Wiley's Memory Game](https://codepen.io/natewiley/pen/BawOqL) under the MIT License.

It was rewritten without jQuery and refactored to modernize the code and optimize it.

This rewrite also adds the following features:
- card source in Markdown, using the [marked.js](https://marked.js.org/) library
- reading an external Markdown file by putting the URL in the hash
- automatic font size adjustment within each card, using the [textFit](https://github.com/STRML/textFit/) library
- ability to use text, an image, or sound in a card, with all possible associations: text/image, text/sound, image/sound …
- access to more advanced features (LaTeX, CSS styles, interface content customization) with a YAML header in the Markdown source.`)
};

export const redirectlabel1 = /** @type {(inputs: Redirectlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy the link to your file here, then click “OK” to open your Memory Game:`)
};

export const redirectplaceholder1 = /** @type {(inputs: Redirectplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your URL`)
};

export const rulesreminder1 = /** @type {(inputs: Rulesreminder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`

**Rule 1**
Separate each card with an empty line.

**Rule 2**
If you want to pair two elements, write the first element on one line, then go to the next line to write the second element: use Markdown syntax to write your text or insert an image.

**Rule 3**
If only a single line is present, instead of pairing two different elements, the card will be repeated twice, and the goal will be to find the identical card.

**Rule 4**
To insert an image, use the classic Markdown syntax \`![](URL_of_the_image)\`

**Rule 5**
To insert an audio file, use the following syntax : \`audio: URL_OF_THE_AUDIO_FILE\`


`)
};